const SITE_URL = siteVariables.site_url;
const AJAX_URL = siteVariables.ajax_url;

document.addEventListener("DOMContentLoaded", (event) => {
	const loadMoreBtn = document.getElementById("loadMoreBtn");
	let page = 1;
	let maxPages;
	const issuesList = document.getElementById("issuesList");

	// If load more btn is clicked
	if (loadMoreBtn && issuesList) {
		loadMoreBtn.addEventListener("click", async (e) => {
			e.preventDefault();
			page++;
			await getIssues();
		});
	}

	async function getIssues() {
		const bodyData = {
			action: "tesl_issues_archive_ajax",
			nonce: siteVariables.tesl_issues_nonce,
			page,
		};

		try {
			const res = await fetch(AJAX_URL, {
				method: "POST",
				headers: { "Content-Type": "application/x-www-form-urlencoded" },
				body: new URLSearchParams(bodyData).toString(),
			});
			if (!res.ok) retrun;
			const resData = await res.json();
			if (!resData.success) return;
			const { data } = resData;

			if (page === 1) {
				issuesList.innerHTML = data.html;
			} else {
				issuesList.innerHTML += data.html;
			}

			if (loadMoreBtn) {
				if (page === data.maxPages) {
					loadMoreBtn.style.display = "none";
				} else {
					loadMoreBtn.style.display = "inline-block";
				}
			}
		} catch (err) {
			console.error("Error:", err);
		}
	}
});
